document.addEventListener('DOMContentLoaded', () => {
  const SELECTORS = {
    activeClass: 'rs-active',
    masterCheckbox: '.rs-table-checkbox__select-all',
    masterCheckboxInput: '.rs-table-header .rs-checkbox__input',
    rowCheckboxHit: '.rs-table-body__checkbox-row', // clickable hit area
    rowCheckboxInput: '.rs-table-body .rs-checkbox__input',
    selectedItemsWrapper: '.rs-selected-items-section',
    selectedItemsCount: '.rs-table-selected-items-count',
    addMoreRowsBtn: '.rs-table-button__add-more',
    tableBody: '.rs-table-body',
    tableRow: '.rs-table-body__row',
    deleteRowButton: '.rs-table-body__row .rs-table-button-delete',
    duplicateRowButton: '.rs-table-body__row .rs-table-button-duplicate',
    duplicateSelectionsButton: '.rs-table-duplicate-selections',
    deleteSelectionsButton: '.rs-table-delete-selections',
    clearSelectionsButton: '.rs-table-clear-selections',
    inputsMaterialNumber: '.rs-material-number-input-wrapper .rs-input',
    inputsQuantity: '.rs-quantity-input-wrapper .rs-input',
    inputsDate: '.rs-date-input-wrapper .rs-input',
  };

  // --- Helpers
  const $ = (s, root = document) => root.querySelector(s);
  const $$ = (s, root = document) => [...root.querySelectorAll(s)];
  const getContentEl = (toggle) => {
    const id = toggle?.getAttribute('aria-controls');
    return id ? document.getElementById(id) : null;
  };

  const els = {
    selectedItemsWrapper: $(SELECTORS.selectedItemsWrapper),
    selectedItemsCount: $(SELECTORS.selectedItemsCount),
    tableBody: $(SELECTORS.tableBody),
    addMoreRowsBtn: $(SELECTORS.addMoreRowsBtn),
  };

  // --- State
  const MAX_ROWS = 200;
  const template = $$(SELECTORS.tableRow)[0] ? $$(SELECTORS.tableRow)[0].cloneNode(true) : null;

  // Ensure count span exists
  if (els.selectedItemsCount && !$('#table-selected-count', els.selectedItemsCount)) {
    els.selectedItemsCount.insertAdjacentHTML('afterbegin', '<span id="table-selected-count">0</span>');
  }
  const countSpan = $('#table-selected-count') || { textContent: '0' };

  const actionsMenuTemplate = template?.querySelector('.rs-actions .rs-actions__content') || null;

  /**
   * cloneNode does not copy `_rsActionsMenuEl`, and a closed menu is detached from the DOM.
   * Restore each row action menu so the host toggle can open again.
   * @param {Element} row
   */
  function resetClonedRowActions(row) {
    if (!(row instanceof Element)) return;
    row.querySelectorAll('.rs-actions').forEach((actionRoot) => {
      if (!(actionRoot instanceof HTMLElement)) return;
      if (window.RsActions && typeof window.RsActions.resetClonedContainer === 'function') {
        window.RsActions.resetClonedContainer(actionRoot, actionsMenuTemplate);
      } else if (window.RsActions && typeof window.RsActions.init === 'function') {
        window.RsActions.init(actionRoot);
      }
    });
  }

  /**
   * Remount the source row menu before cloning so duplicateNode includes `.rs-actions__content`.
   * @param {Element} row
   */
  function prepareRowActionsBeforeClone(row) {
    const sourceActions = row.querySelector('.rs-actions');
    if (!(sourceActions instanceof HTMLElement)) return;
    if (window.RsActions && typeof window.RsActions.resetClonedContainer === 'function') {
      window.RsActions.resetClonedContainer(sourceActions, actionsMenuTemplate);
    } else if (window.RsActions && typeof window.RsActions.close === 'function') {
      window.RsActions.close(sourceActions);
    }
  }


  // --- Selection UI
  function getAllRowCheckboxInputs() {
    // real checkbox inputs inside table body
    return $$('.rs-table-body .rs-checkbox__content input[type="checkbox"]');
  }
  function setRowSelected(row, on) {
    row.classList.toggle('rs-table-body__row--selected', !!on);
  }
  function updateSelectedUI() {
    const checked = getAllRowCheckboxInputs().filter((i) => i.checked).length;
    if (!els.selectedItemsWrapper) return;
    if (checked >= 1) {
      els.selectedItemsWrapper.classList.remove('rs-hidden');
      countSpan.textContent = String(checked);
    } else {
      els.selectedItemsWrapper.classList.add('rs-hidden');
      countSpan.textContent = '0';
    }
  }
  function toggleRowFromHit(hitEl) {
    const row = hitEl.closest(SELECTORS.tableRow);
    if (!row) return;
    const input = row.querySelector('.rs-checkbox__content input[type="checkbox"]');
    if (!input) return;
    input.checked = !input.checked;
    setRowSelected(row, input.checked);
    updateSelectedUI();
  }
  function toggleRowFromHitInput(hitEl) {
    const row = hitEl.closest(SELECTORS.tableRow);
    if (!row) return;
    const input = row.querySelector('.rs-checkbox__content input[type="checkbox"]');
    if (!input) return;
    setRowSelected(row, input.checked);
    updateSelectedUI();
  }
  function toggleAllFromMaster(masterEl) {
    // Master structure has a real input inside its .rs-checkbox__content
    const wrapper = masterEl.closest('.rs-checkbox__content');
    const input = wrapper?.querySelector('input[type="checkbox"]');
    if (!input) return;

    // Flip desired state and sync all rows to it
    const next = !input.checked;
    input.checked = next;

    getAllRowCheckboxInputs().forEach((i) => {
      i.checked = next;
      const row = i.closest(SELECTORS.tableRow);
      if (row) setRowSelected(row, next);
    });

    // Show/hide selection bar (use total rows if selecting all)
    if (next) {
      els.selectedItemsWrapper?.classList.remove('rs-hidden');
      countSpan.textContent = String(getAllRowCheckboxInputs().length);
    } else {
      els.selectedItemsWrapper?.classList.add('rs-hidden');
      countSpan.textContent = '0';
    }
  }

  function toggleAllFromMasterInput(masterEl) {
    getAllRowCheckboxInputs().forEach((i) => {
      i.checked = masterEl.checked;
      const row = i.closest(SELECTORS.tableRow);
      if (row) setRowSelected(row, masterEl.checked);
    });

    // Show/hide selection bar (use total rows if selecting all)
    if (masterEl.checked) {
      els.selectedItemsWrapper?.classList.remove('rs-hidden');
      countSpan.textContent = String(getAllRowCheckboxInputs().length);
    } else {
      els.selectedItemsWrapper?.classList.add('rs-hidden');
      countSpan.textContent = '0';
    }
  }

  function clearSelections() {
    const rows = document.querySelectorAll('.rs-table-body__row');
    rows.forEach((row) => {
      row.classList.remove('rs-table-body__row--selected');
      row.querySelector('.rs-checkbox__content input[type="checkbox"]').checked = false;
    });

    // Uncheck table header master checkbox
    document.querySelector('.rs-table-header .rs-checkbox__input').checked = false;
    document.querySelector('.rs-table-header .rs-checkbox__input').dispatchEvent(new Event('change'));
    updateSelectedUI();
  }

  function deleteSelections() {
    const rows = document.querySelectorAll('.rs-table-body__row');
    rows.forEach((row) => {
      if (row.querySelector('.rs-checkbox__input[type="checkbox"]').checked) {
        row.remove();
      }
    });

    // Check if there are any rows left
    if (!document.querySelector('.rs-table-body__row')) {
      const newRow = template.cloneNode(true);
      resetClonedDateInputs(newRow);
      // Reset inputs & selection state
      newRow.querySelectorAll('input[type="checkbox"]').forEach((cb) => (cb.checked = false));
      newRow.querySelectorAll('input[type="text"], input[type="date"]').forEach((inp) => (inp.value = ''));
      newRow.classList.remove('rs-table-body__row--selected');
      els.tableBody.appendChild(newRow);
      resetClonedRowActions(newRow);
      initDateInputsInContainer(newRow);
    }

    // Reset the check all checkbox
    document.querySelector('.rs-table-header .rs-checkbox__input').checked = false;
    document.querySelector('.rs-table-header .rs-checkbox__input').dispatchEvent(new Event('change'));

    changeAddMoreButton();
    updateSelectedUI();
  }

  function duplicateSelections() {
    const selectedInputs = getAllRowCheckboxInputs().filter(i => i.checked);
    if (selectedInputs.length === 0) return;
    const currentTotal = document.querySelectorAll(SELECTORS.tableRow).length;
    const remainingCapacity = Math.max(0, MAX_ROWS - currentTotal);
    if (remainingCapacity === 0) return;
    const limit = Math.min(selectedInputs.length, remainingCapacity);

    for (let i = 0; i < limit; i++) {
      const row = selectedInputs[i].closest(SELECTORS.tableRow);
      if (!row) continue;
      prepareRowActionsBeforeClone(row);
      const clone = row.cloneNode(true);
      resetClonedDateInputs(clone, true);
      resetClonedRowActions(clone);
      row.insertAdjacentElement('afterend', clone);
      initDateInputsInContainer(clone);
    }

    changeAddMoreButton();
    updateSelectedUI();
  }

  function deleteRow(row) {
    if (window.RsActions && typeof window.RsActions.closeAll === 'function') {
      window.RsActions.closeAll();
    }
    row.remove();
    changeAddMoreButton();
    updateSelectedUI();
  }

  function duplicateRow(row) {
    prepareRowActionsBeforeClone(row);
    const newRow = row.cloneNode(true);
    resetClonedDateInputs(newRow, true);
    resetClonedRowActions(newRow);
    row.insertAdjacentElement('afterend', newRow);
    initDateInputsInContainer(newRow);
    changeAddMoreButton();
    updateSelectedUI();
  }

  /**
   * Row Duplicate/Remove live in the rs-actions menu panel, which attachMenuPanel moves
   * outside `.rs-actions`. Handle those on the table in capture phase so they run
   * before rs-actions closes/detaches the panel (same pattern as rs-warranty-table.js).
   * @param {Event} e
   */
  function handleQuickOrderRowActionClick(e) {
    const target = e.target;
    if (!(target instanceof Element)) return;

    const deleteRowButton = target.closest(SELECTORS.deleteRowButton);
    if (deleteRowButton) {
      deleteRow(deleteRowButton.closest(SELECTORS.tableRow));
      return;
    }

    const duplicateRowButton = target.closest(SELECTORS.duplicateRowButton);
    if (duplicateRowButton) {
      duplicateRow(duplicateRowButton.closest(SELECTORS.tableRow));
    }
  }

  const quickOrderTable = els.tableBody?.closest('.quick-order-table');
  if (quickOrderTable) {
    quickOrderTable.addEventListener('click', handleQuickOrderRowActionClick, true);
  }

  // --- Global click delegation
  document.addEventListener('click', (e) => {
    const target = e.target;

    // Master checkbox hit area
    const master = target.closest(SELECTORS.masterCheckbox);
    if (master) {
      toggleAllFromMaster(master);
      e.preventDefault();
      return;
    }

    // Row checkbox hit area (custom visible box)
    const rowHit = target.closest(SELECTORS.rowCheckboxHit);
    if (rowHit && els.tableBody && els.tableBody.contains(rowHit)) {
      toggleRowFromHit(rowHit);
      e.preventDefault();
      return;
    }

    // Clicks that land on the .rs-checkbox__content container but NOT on the visual span:
    // (a) the native <input> (position:absolute, covers left-middle of span) — browser already pre-toggled it
    // (b) the 4px top/bottom padding dead-zone of the container — nothing was toggled yet
    const checkboxContent = target.closest('.rs-table-body .rs-checkbox__content');
    if (checkboxContent && els.tableBody && els.tableBody.contains(checkboxContent)) {
      const input = checkboxContent.querySelector('input[type="checkbox"]');
      if (!input) return;
      const row = checkboxContent.closest(SELECTORS.tableRow);
      if (!row) return;
      if (target.tagName === 'INPUT') {
        // (a) Native input: browser pre-toggled input.checked before the click event fired.
        //     Just sync the row UI — do NOT preventDefault (change event can also fire safely).
        setRowSelected(row, input.checked);
        updateSelectedUI();
      } else {
        // (b) Padding / container area: nothing was toggled yet, do it manually.
        input.checked = !input.checked;
        setRowSelected(row, input.checked);
        updateSelectedUI();
        e.preventDefault();
      }
      return;
    }

    // Clear selections button
    const clearSelectionsButton = target.closest(SELECTORS.clearSelectionsButton);
    if (clearSelectionsButton) {
      clearSelections();
      return;
    }

    // Delete selections button
    const deleteSelectionsButton = target.closest(SELECTORS.deleteSelectionsButton);
    if (deleteSelectionsButton) {
      deleteSelections();
      return;
    }

    // Duplicate selections button
    const duplicateSelectionsButton = target.closest(SELECTORS.duplicateSelectionsButton);
    if (duplicateSelectionsButton) {
      duplicateSelections();
      return;
    }
  });

  // --- Change event delegation
  // This is used to handle the change event for the master checkbox and the row checkbox
  document.addEventListener('change', (e) => {
    const target = e.target;
    if (!(target instanceof Element) || !target.matches('.rs-checkbox__input')) return;

    const masterInput = target.matches(SELECTORS.masterCheckboxInput);
    if (masterInput) {
      toggleAllFromMasterInput(target);
      return;
    }

    const rowInput = target.matches(SELECTORS.rowCheckboxInput);
    if (rowInput) {
      toggleRowFromHitInput(target);
      return;
    }
  });

  // Close actions on Escape (only if focus is within an open container)
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const openContainer = document.querySelector(`.${SELECTORS.activeClass}`);
    if (openContainer && document.activeElement && openContainer.contains(document.activeElement)) {
      close(openContainer);
    }
  });

  // --- Add More Rows Button Logic
  const arrayThen = ["Then", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine"];
  // --- Update Add More button text & disabled state based on current row count
  const changeAddMoreButton = () => {
    const rows = $$(SELECTORS.tableRow, els.tableBody);
    const duplicateRowButtons = els.tableBody ? els.tableBody.querySelectorAll(SELECTORS.duplicateRowButton) : null;
    const duplicateSelectionsButton = document.querySelector(SELECTORS.duplicateSelectionsButton);
    if (!els.addMoreRowsBtn) return;
    const rowCount = rows.length;
    const toAdd = Math.min(10, Math.max(0, MAX_ROWS - rows.length));
    let btnSpan = els.addMoreRowsBtn.querySelector('span');
    if (btnSpan) {
      if (rowCount >= MAX_ROWS) {
        btnSpan.textContent = window.__t('max_entries_reached', { current: rowCount, max: MAX_ROWS });
        els.addMoreRowsBtn.setAttribute('disabled', 'true');
        if (duplicateRowButtons) duplicateRowButtons.forEach(btn => btn.setAttribute('disabled', 'true'));
        if (duplicateSelectionsButton) duplicateSelectionsButton.setAttribute('disabled', 'true');
      } else if (rowCount >= 990) {
        btnSpan.textContent = window.__t('add_more_entry_fields', { count: arrayThen[toAdd], current: rowCount, max: MAX_ROWS });
        els.addMoreRowsBtn.removeAttribute('disabled');
        if (duplicateRowButtons) duplicateRowButtons.forEach(btn => btn.removeAttribute('disabled'));
        if (duplicateSelectionsButton) duplicateSelectionsButton.removeAttribute('disabled');
      } else {
        btnSpan.textContent = window.__t('add_ten_more_entry_fields', { current: rowCount, max: MAX_ROWS });
        els.addMoreRowsBtn.removeAttribute('disabled');
        if (duplicateRowButtons) duplicateRowButtons.forEach(btn => btn.removeAttribute('disabled'));
        if (duplicateSelectionsButton) duplicateSelectionsButton.removeAttribute('disabled');
      }
    }
  }

  // --- Add more rows (adds 10 per click, up to 990 total)
  if (els.addMoreRowsBtn && els.tableBody) {
    els.addMoreRowsBtn.addEventListener('click', () => {
      const rows = $$(SELECTORS.tableRow, els.tableBody);
      const toAdd = rows.length ? Math.min(10, Math.max(0, MAX_ROWS - rows.length)) : Math.min(10, MAX_ROWS);

      const frag = document.createDocumentFragment();
      for (let i = 0; i < toAdd; i++) {
        const newRow = template.cloneNode(true);
        resetClonedDateInputs(newRow);
        // Reset inputs & selection state
        newRow.querySelectorAll('input[type="checkbox"]').forEach((cb) => (cb.checked = false));
        newRow.querySelectorAll('input[type="text"], input[type="date"]').forEach((inp) => (inp.value = ''));
        newRow.classList.remove('rs-table-body__row--selected');
        resetClonedRowActions(newRow);
        frag.appendChild(newRow);
      }
      els.tableBody.appendChild(frag);

      // Keep selection UI consistent
      initDateInputsInContainer(els.tableBody);
      changeAddMoreButton();
      updateSelectedUI();
    });
  }

  const dateInputSelector = 'input[type="text"].rs-input-type__date';

  /**
   * Cloned rows inherit Flatpickr's DOM (alt input, flatpickr-input class) but not a working
   * `._flatpickr` ref, so initDateInputs skips them. Reset to a plain type=date input first.
   * @param {Element} row
   * @param {boolean} [preserveValues=false]
   */
  function resetClonedDateInputs(row, preserveValues = false) {
    row.querySelectorAll('.rs-date-input-wrapper').forEach((wrap) => {
      const originalInput =
        wrap.querySelector('input.flatpickr-input') ||
        wrap.querySelector('input[type="date"].rs-input-type__date');
      if (!originalInput) return;

      const wrapper = originalInput.closest('.rs-input__wrapper');
      const altDisplay = wrapper?.querySelector('input[type="text"].rs-input-type__date:not([name])');
      const preserved = preserveValues ? (altDisplay?.value || originalInput.value || '') : '';

      const existingFp = originalInput._flatpickr;
      if (existingFp && typeof existingFp.destroy === 'function') {
        try {
          existingFp.destroy();
        } catch {
          /* ignore */
        }
      }

      originalInput.type = 'date';
      originalInput.classList.remove('flatpickr-input');
      originalInput.removeAttribute('style');

      const datePlaceholder =
        (typeof window.__t === 'function' && window.__t('date_placeholder')) || 'mm/dd/yyyy';
      originalInput.setAttribute('placeholder', datePlaceholder);

      if (wrapper) {
        wrapper.querySelectorAll('input').forEach((el) => {
          if (el === originalInput) return;
          if (
            el.getAttribute('type') === 'text' &&
            (el.classList.contains('rs-input-type__date') || el.classList.contains('rs-input'))
          ) {
            el.remove();
          }
        });
      }

      originalInput.value = preserved;
    });
  }

  /**
   * Initialize Flatpickr on date inputs within a container.
   * Skips inputs that already have the flatpickr-input class.
   * @param {Element} container - Element to search for date inputs (e.g. row or tableBody)
   */
  function initDateInputsInContainer(container) {
    if (typeof window.initDateInputs === 'function') {
      window.initDateInputs(container);
    }
  }


  // --- Inputs Copy/Paste Support
  $$(SELECTORS.inputsMaterialNumber).forEach((input) => {
    input.addEventListener('paste', (e) => {
      const paste = (e.clipboardData || window.clipboardData).getData('text');
      if (!paste) return;
      const allCheckboxses = getAllRowCheckboxInputs();
      const checked = allCheckboxses.filter((i) => i.checked);
      if (!checked.length) return;
      const values = paste.split(/\s+/).filter((v) => v.trim().length);
      if (!values.length) return;
      e.preventDefault();

      // Paste values into checked rows, one per row
      for (let i = 0; i < checked.length; i++) {
        const row = checked[i].closest(SELECTORS.tableRow);
        if (!row) continue;
        const inp = row.querySelector(SELECTORS.inputsMaterialNumber);
        if (!inp) continue;
        inp.value = values[i] || '';
      }
    });
  });

  $$(SELECTORS.inputsQuantity).forEach((input) => {
    input.addEventListener('paste', (e) => {
      const paste = (e.clipboardData || window.clipboardData).getData('text');
      if (!paste) return;
      const allCheckboxses = getAllRowCheckboxInputs();
      const checked = allCheckboxses.filter((i) => i.checked);
      if (!checked.length) return;
      const values = paste.split(/\s+/).filter((v) => v.trim().length && !isNaN(v));
      if (!values.length) return;
      e.preventDefault();

      // Paste values into checked rows, one per row
      for (let i = 0; i < checked.length; i++) {
        const row = checked[i].closest(SELECTORS.tableRow);
        if (!row) continue;
        const inp = row.querySelector(SELECTORS.inputsQuantity);
        if (!inp) continue;
        inp.value = values[i] || '';
      }
    });
  });

  $$(SELECTORS.inputsDate).forEach((input) => {
    input.addEventListener('paste', (e) => {
      const paste = (e.clipboardData || window.clipboardData).getData('text');
      if (!paste) return;
      const allCheckboxses = getAllRowCheckboxInputs();
      const checked = allCheckboxses.filter((i) => i.checked);
      if (!checked.length) return;
      const values = paste.split(/\s+/).filter((v) => v.trim().length && !isNaN(Date.parse(v)));
      if (!values.length) return;
      e.preventDefault();

      // Paste values into checked rows, one per row
      for (let i = 0; i < checked.length; i++) {
        const row = checked[i].closest(SELECTORS.tableRow);
        if (!row) continue;
        const inp = row.querySelector(SELECTORS.inputsDate);
        if (!inp) continue;
        inp.value = values[i] || '';
      }
    });
  });

});
